import { useRef, useCallback } from 'react'

import Sticky from 'app/common/templates-next/sticky'
import Prompt from 'app/components/common/Prompt'

import { useExternalServicesSettings } from './useExternalServicesSettings'
import { MachineHistory } from '../../MachineHistory'
import sections, { sectionTitles } from '../sections'

import styles from './ExternalServices.module.scss'
import { ExternalServicesSelector } from './ExternalServicesSelector'
import { useVendingMachineSingle } from 'app/dataProviders/VendingDataProvider'
import { Header2, PageTemplateContent } from 'app/common/templates-next/page-template'
import SaveCancelButtons from 'app/components/common/SaveCancelButtons'

const currentSection = sections.VENDING_INTEGRATION_EXTERNAL_SERVICES_SETTINGS
const header = sectionTitles[currentSection]

/**
 *  Форма "Интеграция со внешними сервисами"
 */

export const ExternalServices = () => {
  const [{ id: machineId, title }] = useVendingMachineSingle()

  const [
    {
      availablePermissions,
      machineExtService,
      pending,
      loading: loadingMachineServices,
      modified,
      selectedExternalService,
    },
    { submit, modify, request },
  ] = useExternalServicesSettings({ machineId })

  const formRef = useRef<HTMLFormElement | null>(null)

  const handleSave = useCallback(
    (/* e: SyntheticEvent<HTMLButtonElement> */) => {
      if (formRef.current) {
        if (formRef.current.requestSubmit) {
          formRef.current.requestSubmit()
          return
        }
        ;(formRef.current as any).submit.click()
      }
    },
    [],
  )

  const loading = pending || loadingMachineServices

  return (
    <>
      <Sticky>
        {(ref, _, shadow) => (
          <PageTemplateContent horizontalLayout shadowBottom={shadow} reference={ref}>
            <div className={styles.headerContent}>
              <Header2 skipMargin wide>
                {header}
              </Header2>
              <MachineHistory key={machineId} machineId={machineId} title={title} />
            </div>
            {modified && (
              <SaveCancelButtons
                onSave={handleSave}
                onCancel={request}
                disabled={loading || pending}
                saving={pending}
                cancelling={modified && loading}
              />
            )}
          </PageTemplateContent>
        )}
      </Sticky>

      <PageTemplateContent>
        <form onSubmit={submit} ref={formRef} id="external_services_settings_form">
          <ExternalServicesSelector
            machineId={machineId}
            machineExtService={machineExtService}
            selectedExternalService={selectedExternalService}
            loadingMachineServices={loadingMachineServices}
            disabled={!availablePermissions.allowExternalService || loading}
            onModify={modify}
          />
          {/* <ExternalServiceKey
            machineId={machineId}
            disabled={!availablePermissions.allowExternalService || !currentPermissions.enableExternalServices}
          /> */}

          <button type="submit" name="submit" className={styles.hidden}>
            {'Сохранить'}
          </button>
        </form>
      </PageTemplateContent>

      <Prompt when={modified} message="Вы не сохранили изменения, перейти в любом случае?" />
    </>
  )
}
